import React, { useEffect, useState } from "react";
import { Badge, Card, Spinner, Form, Label } from "reactstrap";
import { BiEdit, BiMinus, BiPlus } from "react-icons/bi";
import MyDataTable from "../../myComponents/DataTable/MyDataTable";
import { addOrgStrAPI, editOrgStructureAPI, getOrgStructureAPI } from "../../api/banner";
import { useForm } from "react-hook-form";
import Select from "react-select";
import { toast } from "react-toastify";
import ConfirmModal from "../../myComponents/modals/ConfirmModal";
import { updateOrgStrStatusAPI } from "../../api/menu";
import { decrypt, encrypt } from "../../utils/Encrypt";
import {
  Block,
  BlockBetween,
  BlockHead,
  BlockHeadContent,
  BlockTitle,
  Button,
  Col,
  Icon,
  PreviewAltCard,
  Row,
} from "../../components/Component";
import Head from "../../layout/head/Head";
import Content from "../../layout/content/Content";
import useLogout from "../../hooks/useLogout";

const OrgStructure = () => {
     const logout = useLogout();
  const [isOpen, setIsOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [mode, setMode] = useState("Add");
  const IMAGE_BASE_URL = localStorage.getItem("IMAGE_BASE_URL");
  const [data, setData] = useState([]);
  const [imageOpen, setImageOpen] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [column, setColumn] = useState([
    {
      name: "Heading (EN)",
      selector: (row) => row?.heading,
      sortable: true,
    },
    {
      name: "Heading (HN)",
      selector: (row) => row?.hn_heading,
      sortable: true,
    },
    {
      name: "Title (EN)",
      selector: (row) => row?.title,
      sortable: true,
    },
    {
      name: "Title (HN)",
      selector: (row) => row?.hn_title,
      sortable: true,
    },
    {
      name: "Description (EN)",
      selector: (row) => row?.description,
      sortable: true,
      wrap: true,
    },
    {
      name: "Description (HN)",
      selector: (row) => row?.hn_description,
      sortable: true,
      wrap: true,
    },
    {
      name: "Status",
      selector: (row) => row?.status,
      cell: (row) => (
        <div style={{ cursor: "pointer" }} onClick={() => handleToggleStatus(row)}>
          <Badge color={`${row.status === true ? "success" : "danger"}`}>
            {row.status === true ? "Active" : "Inactive"}
          </Badge>
        </div>
      ),
      sortable: true,
      wrap: true,
    },
    {
      name: "Action",
      wrap: true,
      cell: (row) => (
        <div>
          <Button outline color={`warning`} size={`xs`} className={`me-1`} onClick={() => handleEdit(row)}>
            {" "}
            <BiEdit />
          </Button>
          {/* <Button outline color={`danger`} size={`xs`} onClick={() => handleDelete(row)}>
                  {" "}
                  <Icon name="trash"></Icon>
                </Button> */}
        </div>
      ),
    },
  ]);

  const {
    register,
    handleSubmit,
    reset,
    watch,
    setValue,
    trigger,
    formState: { errors },
  } = useForm({});

  useEffect(() => {
    getOrganisationalAPI();
  }, []);
  const getOrganisationalAPI = () => {
    const data = {};

    getOrgStructureAPI(data)
      .then((res) => {
        // decrypt data
        const status = decrypt(res.data.status);

        if (status === "success") {
          const decryptedResponse = decrypt(res.data.data.tableData);
          toast.success(res.data.message);
          setData(decryptedResponse);
          toast.clearWaitingQueue();
        } else if (status === "failed") {
          toast.warning(res.data.message);
          toast.clearWaitingQueue();
          setData([]);
        } else if (status === "expired") {
          toast.error(res.data.message);
          logout();
        }
      })
      .catch((err) => {});
  };

  const handleEdit = (row) => {
    window.scrollTo(0,0)
    setIsOpen(!isOpen);
    setMode("Edit");
    setValue("id", row.id); // Add this for consistent `formData` structure
    setValue("heading", row.heading);
    setValue("heading_hindi", row.hn_heading);
    setValue("title", row.title);
    setValue("title_hindi", row.hn_title);
    setValue("desc", row.description);
    setValue("desc_hindi", row.hn_description);
    setValue("status", {
      label: row.status === true ? "Active" : "Inactive",
      value: row.status === true ? true : false,
    });
    setMode("Edit"); // Set mode to Edit
    setIsOpen(true); // Open the form modal
  };

  const module = "Organisational_str";
  const onFormSubmit = (data) => {
    setIsLoading(true);
    const bodyData = {
      id: data.id,
      hn_heading: data.heading_hindi,
      heading: data.heading,
      hn_title: data.title_hindi,
      title: data.title,
      description: data.desc,
      hn_description: data.desc_hindi,
      status: data.status.value,
      module: module,
    };

    const encryptedData = encrypt(bodyData);
    const encryptData = {
      zero: encryptedData,
    };

    if (mode === "Add") {
      addOrgStrAPI(encryptData)
        .then((res) => {
          const status = decrypt(res.data.status);
          if (status == "success") {
            toast.success(res.data.message);
            toast.clearWaitingQueue();
            getOrganisationalAPI();
            setIsOpen(false);
            setIsLoading(false);
          } else if (status === "failed") {
            setIsLoading(false);
            toast.error(res.data.message);
            toast.clearWaitingQueue();
          } else if (status === "expired") {
            setIsLoading(false);
            toast.error(res.data.message);
            toast.clearWaitingQueue();
            logout();
          }
        })
        .catch((err) => {
          console.error(err);
        });
    }

    if (mode === "Edit") {
      editOrgStructureAPI(encryptData)
        .then((res) => {
          const status = decrypt(res.data.status);
          if (status == "success") {
            toast.success(res.data.message);
            getOrganisationalAPI();
            setIsOpen(false);
            setIsLoading(false);
          } else if (status === "failed") {
            setIsLoading(false);
            toast.error(res.data.message);
            toast.clearWaitingQueue();
          } else if (status === "expired") {
            setIsLoading(false);
            toast.error(res.data.message);
            toast.clearWaitingQueue();
            logout();
          }
        })
        .catch((err) => {
          console.error(err);
        });
    }
  };

  const handleStatusChange = (selectedOption) => {
    setValue("status", selectedOption || "");
    trigger("status");
  };

  const handleToggleStatus = (row) => {
    setValue("id", row.id);
    setValue("status", row.status);
    setShowModal(true);
  };
  const confirmStatusChange = () => {
    const data = {
      id: watch("id"),
      status: watch("status"),
    };

    const encryptedData = encrypt(data);
    const encryptData = {
      zero: encryptedData,
    };

    updateOrgStrStatusAPI(encryptData)
      .then((res) => {
        const status = decrypt(res.data.status);
        if (status === "success") {
          getOrganisationalAPI();
          toast.success(res.data.message);
          toast.clearWaitingQueue();
        } else if (status === "failed") {
          toast.error(res.data.message);
          toast.clearWaitingQueue();
        } else if (status === "expired") {
          toast.error(res.data.message);
          toast.clearWaitingQueue();
          logout();
        }
      })
      .catch((err) => console.error("Error updating status:", err));
    setShowModal(false);
  };
  return (
    <>
      <Head title={"Organizational Structure"} />
      <Content>
        <BlockHead size={`sm`}>
          <BlockBetween>
            <BlockHeadContent>
              <BlockTitle page tag="h3">
                {"Organizational Structure"}
              </BlockTitle>
            </BlockHeadContent>
            <BlockHeadContent>
              <div className="">
                <Button
                  color="primary"
                  outline
                  className={`  me-n1`}
                  onClick={() => {
                    setIsOpen((pre) => !pre);
                    setMode("Add");
                    reset();
                  }}
                >
                  <Icon name={isOpen ? "minus" : "plus"} />
                </Button>
              </div>
            </BlockHeadContent>
          </BlockBetween>
        </BlockHead>
        <Block>
          <Row className={`g-gs`}>
            {isOpen && (
              <PreviewAltCard>
                <Form onSubmit={handleSubmit(onFormSubmit)}>
                  <Row className={``}>
                    <Col md="12" className={`mb-5`}>
                      <div className="form-group">
                        <Label className="form-label me-3">Heading</Label>
                        <div className="w-100 d-flex gap-2">
                          <div className="w-100">
                            <input
                              id="heading"
                              placeholder="Enter Heading (English)"
                              type="text"
                              className="form-control"
                              {...register("heading", {
                                required: "Heading is required",
                              })}
                            />
                            {errors.heading && (
                              <span
                                className="invalid"
                                style={{
                                  color: "#e85347",
                                  fontSize: "11px",
                                  fontStyle: "italic",
                                }}
                              >
                                {errors.heading.message}
                              </span>
                            )}
                          </div>
                          <div className="w-100">
                            <input
                              id="heading_hindi"
                              placeholder="शीर्षक दर्ज करें (Hindi)"
                              type="text"
                              className="form-control"
                              {...register("heading_hindi", {
                                required: "शीर्षक आवश्यक है",
                                pattern: {
                                  value: /^[\u0900-\u097F\s\w]+$/,
                                  message: "केवल हिंदी में दर्ज करें",
                                },
                              })}
                            />
                            {errors.heading_hindi && (
                              <span
                                className="invalid"
                                style={{
                                  color: "#e85347",
                                  fontSize: "11px",
                                  fontStyle: "italic",
                                }}
                              >
                                {errors.heading_hindi.message}
                              </span>
                            )}
                          </div>
                        </div>
                      </div>
                    </Col>
                 
                    <Col md="12" className={`mb-5`}>
                      <div className="form-group">
                        <Label className="form-label me-3">Title</Label>
                        <div className="w-100 d-flex gap-2">
                          <div className="w-100">
                            <input
                              id="title"
                              placeholder="Enter Title (English)"
                              type="text"
                              className="form-control"
                              {...register("title", {
                                required: "Title is required",
                              })}
                            />
                            {errors.title && (
                              <span
                                className="invalid"
                                style={{
                                  color: "#e85347",
                                  fontSize: "11px",
                                  fontStyle: "italic",
                                }}
                              >
                                {errors.title.message}
                              </span>
                            )}
                          </div>
                          <div className="w-100">
                            <input
                              id="title_hindi"
                              placeholder="शीर्षक दर्ज करें (Hindi)"
                              type="text"
                              className="form-control"
                              {...register("title_hindi", {
                                required: "शीर्षक आवश्यक है",
                                pattern: {
                                  value: /^[\u0900-\u097F\s\w]+$/,
                                  message: "केवल हिंदी में दर्ज करें",
                                },
                              })}
                            />
                            {errors.title_hindi && (
                              <span
                                className="invalid"
                                style={{
                                  color: "#e85347",
                                  fontSize: "11px",
                                  fontStyle: "italic",
                                }}
                              >
                                {errors.title_hindi.message}
                              </span>
                            )}
                          </div>
                        </div>
                      </div>
                    </Col>
                 
                    <Col md="12" className={`mb-5`}>
                      <div className="form-group">
                        <Label className="form-label me-3">Description</Label>
                        <div className="w-100 d-flex gap-2">
                          <div className="w-100">
                            <textarea
                              id="desc"
                              placeholder="Enter Description (English)"
                              className="form-control"
                              {...register("desc", {
                                required: "Description is required",
                              })}
                            />
                            {errors.desc && (
                              <span
                                className="invalid"
                                style={{
                                  color: "#e85347",
                                  fontSize: "11px",
                                  fontStyle: "italic",
                                }}
                              >
                                {errors.desc.message}
                              </span>
                            )}
                          </div>
                          <div className="w-100">
                            <textarea
                              id="desc_hindi"
                              placeholder="विवरण दर्ज करें (Hindi)"
                              className="form-control"
                              {...register("desc_hindi", {
                                required: "विवरण आवश्यक है",
                                pattern: {
                                  value: /^[\u0900-\u097F\s\w]+$/,
                                  message: "केवल हिंदी में दर्ज करें",
                                },
                              })}
                            />

                            {errors.desc_hindi && (
                              <span
                                className="invalid"
                                style={{
                                  color: "#e85347",
                                  fontSize: "11px",
                                  fontStyle: "italic",
                                }}
                              >
                                {errors.desc_hindi.message}
                              </span>
                            )}
                          </div>
                        </div>
                      </div>
                    </Col>
                 
                   
                  </Row>
                  <Row className={'mt-5'}>
                     <Col md="4" className={`mt-5`}>
                      <div className="form-group">
                        <Label className="from-label" htmlFor="status">
                          Status
                        </Label>
                        <div className="form-control-wrap">
                          <Select
                            id="status"
                            options={[
                              { value: true, label: "Active" },
                              { value: false, label: "InActive" },
                            ]}
                            {...register("status", {
                              required: "Please select status",
                            })}
                            onChange={handleStatusChange}
                            value={watch("status")}
                          />
                          {errors.status && (
                            <span
                              className="invalid"
                             
                            >
                              {errors?.status?.message}
                            </span>
                          )}
                        </div>
                      </div>
                    </Col>
                  </Row>
                  <Col md="2" className={``}>
                    <div className="form-group" style={{ marginTop: "31px" }}>
                      <Button disabled={isLoading} color="primary" size="md">
                        {isLoading ? <Spinner size="sm" color="primary" /> : mode == "Add" ? "Save" : "Update"}
                      </Button>
                    </div>
                  </Col>
                </Form>
              </PreviewAltCard>
            )}
            <MyDataTable data={data} columns={column} title="Organizational data" isLoading={isLoading} />
          </Row>
        </Block>
        <ConfirmModal
          isOpen={showModal}
          toggle={() => setShowModal(!showModal)}
          onConfirm={confirmStatusChange}
          status={watch("status")}
        />
      </Content>
    </>
  );
};

export default OrgStructure;
